import { render } from "./Dbfields.vue?vue&type=template&id=279bc40f&scoped=true"
import script from "./Dbfields.vue?vue&type=script&lang=js"
export * from "./Dbfields.vue?vue&type=script&lang=js"

import "./Dbfields.vue?vue&type=style&index=0&id=279bc40f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279bc40f"]])

export default __exports__